(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-fw-pdp]";
  var MAX_STEP      = 2;

  var COLOUR_SWATCHES = {
    "the dahlia":      { hex: "#1c1c1c", cls: "" },
    "the orchid":      { hex: "#ffffff", cls: "fw-swatch--orchid" },
    "the honeysuckle": { hex: "#6e533f", cls: "" }
  };

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root || root.hasAttribute("data-fw-ready")) return;
    root.setAttribute("data-fw-ready", "true");

    var steps  = Array.prototype.slice.call(root.querySelectorAll(".fw-step"));
    var crumbs = Array.prototype.slice.call(root.querySelectorAll("[data-fw-crumb]"));
    var uploadElRef = null;

    
    root.addEventListener("click", function (e) {
      var nextBtn = e.target.closest("[data-fw-next]");
      var backBtn = e.target.closest("[data-fw-back]");
      var gotoBtn = e.target.closest("[data-fw-goto]");

      if (nextBtn) {
        e.preventDefault();
        goToStep(getActive(root) + 1, root, steps, crumbs);
      } else if (backBtn) {
        e.preventDefault();
        var currentStep = getActive(root);
        if (currentStep === 2 && uploadElRef) {
          root.removeAttribute("data-fw-uploaded");
          root.removeAttribute("data-fw-img-w");
          root.removeAttribute("data-fw-img-h");
          root.removeAttribute("data-fw-defaults-set");
          root.removeAttribute("data-fw-size-gate-init");

          var pondRoot = uploadElRef.querySelector(".filepond--root") || uploadElRef;
          var pondInst = pondRoot._pond;
          if (pondInst && typeof pondInst.removeFiles === "function") {
            pondInst.removeFiles();
          } else {
            var pondItems = Array.prototype.slice.call(uploadElRef.querySelectorAll(".filepond--item"));
            pondItems.forEach(function (item) {
              var revertBtn = item.querySelector('[class*="revert"]');
              var rmBtn     = item.querySelector('[class*="remove"]');
              if (revertBtn) {
                revertBtn.click();
                setTimeout(function () {
                  var rm2 = uploadElRef.querySelector('[class*="remove"]');
                  if (rm2) rm2.click();
                }, 600);
              } else if (rmBtn) {
                rmBtn.click();
              }
            });
          }
        }
        goToStep(currentStep - 1, root, steps, crumbs);
      } else if (gotoBtn) {
        var t = parseInt(gotoBtn.getAttribute("data-fw-goto"), 10);
        e.preventDefault();
        goToStep(t, root, steps, crumbs);
      }
    });

    
    waitForUploadField(function (uploadEl) {
      uploadElRef = uploadEl;
      linkLabel(root, uploadEl);
      listenForUpload(uploadEl, root, steps, crumbs);
      injectProgressBar(root, uploadEl);
      trackImageDimensions(root, uploadEl);
    });

    
    
    
    initCartRedirect();

    
    reorderFrameOptions();
    injectColourSwatches();
    forceShowVariantSelector();
    initLowresLightbox(root, steps, crumbs);

    
    
    initStickyOffset();

    goToStep(1, root, steps, crumbs);
  }

  

  function getActive(root) {
    return parseInt(root.getAttribute("data-fw-active-step") || "1", 10);
  }

  function goToStep(n, root, steps, crumbs) {
    if (isNaN(n) || n < 1) n = 1;
    if (n > MAX_STEP) n = MAX_STEP;

    
    if (n >= 2 && !root.hasAttribute("data-fw-uploaded")) {
      showUploadError(root);
      return;
    }

    root.setAttribute("data-fw-active-step", String(n));
    document.body.setAttribute("data-fw-step", String(n));

    steps.forEach(function (step) {
      step.hidden = parseInt(step.getAttribute("data-step"), 10) !== n;
    });

    crumbs.forEach(function (crumb) {
      var idx = parseInt(crumb.getAttribute("data-fw-crumb"), 10);
      var active = idx === n;
      crumb.classList.toggle("is-active", active);
      var btn = crumb.querySelector(".fw-steps__btn");
      if (btn) {
        if (active) btn.setAttribute("aria-current", "step");
        else        btn.removeAttribute("aria-current");
      }
    });

    if (n === 2) {
      tagProductInfoColumn();
      forceShowVariantSelector();
      
      if (!root.hasAttribute("data-fw-defaults-set")) {
        selectDefaultVariants(root);
      }
      
      triggerVariantPriceUpdate();
      setTimeout(function () { window.dispatchEvent(new Event("resize")); }, 200);
      
      injectVariantSubtitle();
      
      injectSizeDimensions(root);
      setTimeout(function () { injectSizeDimensions(root); }, 1200);
      stripColourNamePrefix();
      initSizeClickGate(root, steps, crumbs);
      
      
      var buyBtnsStep2 = document.querySelector('[data-frame-ref="buyButtons"]');
      if (buyBtnsStep2) {
        Array.prototype.slice.call(buyBtnsStep2.children).forEach(function (child) {
          child.style.removeProperty("display");
        });
      }
      
      injectGiftFields(root, buyBtnsStep2 || null);
    }

    if (typeof root.scrollIntoView === "function") {
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    
    
    if (n === 1 && !root.hasAttribute("data-fw-init-scrolled")) {
      root.setAttribute("data-fw-init-scrolled", "true");
      setTimeout(function () {
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 1200);
    }
  }

  

  
  function waitForUploadField(cb) {
    var el = document.querySelector('[data-frame-ref="uploadField"]');
    if (el) { cb(el); return; }

    var obs = new MutationObserver(function () {
      var found = document.querySelector('[data-frame-ref="uploadField"]');
      if (found) { obs.disconnect(); cb(found); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 10000);
  }

  
  
  function linkLabel(root, uploadEl) {
    var label = root.querySelector("[data-fw-upload-label]");
    if (!label) return;

    function tryLink() {
      var input = uploadEl.querySelector(".filepond--browser") ||
                  uploadEl.querySelector('input[type="file"]');
      if (!input) return false;
      var id = input.id || input.getAttribute("id");
      if (!id) return false;
      label.setAttribute("for", id);
      return true;
    }

    if (tryLink()) return;

    
    var obs = new MutationObserver(function () {
      if (tryLink()) obs.disconnect();
    });
    obs.observe(uploadEl, { childList: true, subtree: true, attributes: true });
    setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 10000);
  }

  
  function listenForUpload(uploadEl, root, steps, crumbs) {
    uploadEl.addEventListener("FilePond:processfile", function (e) {
      if (e.detail && e.detail.error) return; 
      root.setAttribute("data-fw-uploaded", "true");
      var errMsg = root.querySelector(".fw-upload-error-msg");
      if (errMsg) errMsg.hidden = true;
      setTimeout(function () {
        goToStep(2, root, steps, crumbs);
      }, 700);
    });

    
    uploadEl.addEventListener("FilePond:removefile", function () {
      root.removeAttribute("data-fw-uploaded");
      root.removeAttribute("data-fw-defaults-set");
    });
  }

  

  
  
  
  function selectDefaultVariants(root) {
    clickOptionByText('[data-handle="frame-colour"]', 'dahlia');
    clickOptionByText('[data-handle="frame-size"]', 'standard');
    clickOptionByText('[data-handle="mount"]', 'standard');
    root.setAttribute("data-fw-defaults-set", "true");
  }

  
  function clickOptionByText(fieldsetSelector, text) {
    var fieldset = document.querySelector(fieldsetSelector);
    if (!fieldset) return;
    var labels = fieldset.querySelectorAll(
      '.variant-input label, .frame-product-option-value'
    );
    var found = false;
    labels.forEach(function (lbl) {
      if (found) return;
      if ((lbl.textContent || "").trim().toLowerCase().indexOf(text) !== -1) {
        lbl.click();
        found = true;
      }
    });
  }

  

  function showUploadError(root) {
    var panel = root.querySelector(".fw-upload-panel");
    if (panel) panel.classList.add("fw-upload-panel--error");
    var msg = root.querySelector(".fw-upload-error-msg");
    if (!msg) {
      msg = document.createElement("p");
      msg.className = "fw-upload-error-msg";
      msg.textContent = "Please upload a photo before continuing.";
      if (panel) panel.parentNode.insertBefore(msg, panel.nextSibling);
    }
    msg.hidden = false;
    setTimeout(function () {
      if (panel) panel.classList.remove("fw-upload-panel--error");
    }, 600);
  }

  

  
  
  
  function triggerVariantPriceUpdate() {
    setTimeout(function () {
      var checked = document.querySelector(
        '[data-frame-ref="variantSelector"] input[type="radio"]:checked'
      );
      if (checked) {
        checked.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }, 1500);
  }

  

  
  
  
  function injectProgressBar(root, uploadEl) {
    var step1 = root.querySelector("[data-step='1']");
    if (!step1 || step1.querySelector(".fw-upload-progress")) return;

    var bar = document.createElement("div");
    bar.className = "fw-upload-progress";
    bar.setAttribute("aria-live", "polite");
    bar.style.display = "none";
    bar.innerHTML =
      '<div class="fw-upload-progress__track" role="progressbar" ' +
      'aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">' +
      '<div class="fw-upload-progress__fill"></div></div>' +
      '<p class="fw-upload-progress__label">Preparing your photo\u2026</p>';
    
    var usps = step1.querySelector(".fw-usps");
    if (usps) {
      step1.insertBefore(bar, usps);
    } else {
      step1.appendChild(bar);
    }

    var fill  = bar.querySelector(".fw-upload-progress__fill");
    var label = bar.querySelector(".fw-upload-progress__label");
    var track = bar.querySelector(".fw-upload-progress__track");

    function setProgress(pct) {
      fill.style.width = pct + "%";
      track.setAttribute("aria-valuenow", String(pct));
    }

    var uploading = false;
    function onProgress(e) {
      if (!e.detail || typeof e.detail.progress !== "number") return;
      var pct = Math.max(0, Math.min(100, Math.round(e.detail.progress * 100)));
      uploading = true;
      bar.style.display = "";
      setProgress(Math.max(pct, 3));
      label.textContent = "Uploading your photo \u00b7 " + pct + "%";
    }

    uploadEl.addEventListener("FilePond:addfilestart", function () {
      uploading = false;
      bar.style.display = "";
      setProgress(3);
      label.textContent = "Preparing your photo\u2026";
    });

    uploadEl.addEventListener("FilePond:processfilestart", function () {
      bar.style.display = "";
      setProgress(3);
      label.textContent = "Uploading your photo \u00b7 0%";
    });

    // FilePond reports upload progress as processfileprogress; keep the older
    // name too in case the uploader changes.
    uploadEl.addEventListener("FilePond:processfileprogress", onProgress);
    uploadEl.addEventListener("FilePond:progress", onProgress);

    uploadEl.addEventListener("FilePond:processfile", function (e) {
      if (e.detail && e.detail.error) { bar.style.display = "none"; return; }
      setProgress(100);
      label.textContent = "Uploaded \u00b7 100%. Choosing your frame\u2026";
      setTimeout(function () { bar.style.display = "none"; }, 900);
    });
  }

  

  
  
  
  
  function initStickyOffset() {
    if (window._fwStickyOffsetInit) return;
    window._fwStickyOffsetInit = true;

    function measure() {
      
      var header =
        document.getElementById("SiteHeader") ||
        document.querySelector(".site-header") ||
        document.querySelector("header[role='banner']") ||
        document.querySelector("header");

      var h = header ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty("--fw-header-h", Math.round(h) + "px");
    }

    measure();
    window.addEventListener("resize", measure, { passive: true });
    
    setTimeout(measure, 600);
  }

  

  function forceShowVariantSelector() {
    var vs = document.querySelector('[data-frame-ref="variantSelector"]');
    if (vs) vs.style.removeProperty("display");
  }

  function reorderFrameOptions() {
    var container = document.querySelector('[data-frame-ref="variantSelector"]');
    if (!container || container.getAttribute("data-fw-reordered")) return;

    var wrappers = Array.prototype.slice.call(container.querySelectorAll(".variant-wrapper"));
    var colour = null, size = null, mount = null;
    wrappers.forEach(function (w) {
      if      (w.querySelector('[data-handle="frame-colour"]')) colour = w;
      else if (w.querySelector('[data-handle="frame-size"]'))   size   = w;
      else if (w.querySelector('[data-handle="mount"]'))        mount  = w;
    });
    if (!colour || !size || !mount) return;

    container.appendChild(colour);
    container.appendChild(size);
    container.appendChild(mount);
    container.setAttribute("data-fw-reordered", "true");
  }

  function injectColourSwatches() {
    var fieldset = document.querySelector('fieldset[data-handle="frame-colour"]');
    if (!fieldset) return;

    fieldset.querySelectorAll(".frame-product-option-value--color").forEach(function (colorDiv) {
      if (colorDiv.querySelector(".fw-swatch")) return;

      var nameEl = colorDiv.querySelector(".frame-product-option-value__name");
      if (!nameEl) return;

      var key  = nameEl.textContent.trim().toLowerCase();
      var data = COLOUR_SWATCHES[key];
      if (!data) return;

      var span = document.createElement("span");
      span.className = "fw-swatch" + (data.cls ? " " + data.cls : "");
      span.style.backgroundColor = data.hex;
      span.setAttribute("aria-hidden", "true");
      colorDiv.insertBefore(span, nameEl);
    });
  }

  

  
  
  
  
  function injectVariantSubtitle() {
    if (document.querySelector("[data-fw-variant-subtitle]")) return;

    var colourWrapper = document.querySelector(
      '[data-handle="frame-colour"]'
    );
    if (!colourWrapper) return;

    
    var wrapper = colourWrapper.closest(".variant-wrapper") || colourWrapper;

    var p = document.createElement("p");
    p.className = "fw-variant-subtitle";
    p.setAttribute("data-fw-variant-subtitle", "");
    p.textContent =
      "Pick a colour, size and mount. Your photo updates as you go.";

    wrapper.parentNode.insertBefore(p, wrapper);
  }

  

  function tagProductInfoColumn() {
    var layout = document.querySelector('.frame-product__layout');
    if (!layout) return;

    if (!document.querySelector('.fw-product-info-col')) {
      var vs = document.querySelector('[data-frame-ref="variantSelector"]');
      if (vs) {
        var node = vs;
        while (node && node.parentElement !== layout) {
          node = node.parentElement;
        }
        if (node && node.parentElement === layout) {
          node.classList.add('fw-product-info-col');
        }
      }
    }

    var ancestor = layout.parentElement;
    while (ancestor && ancestor !== document.body) {
      var cpt = parseFloat(window.getComputedStyle(ancestor).paddingTop) || 0;
      if (cpt > 15 && !ancestor.hasAttribute('data-fw-gap-zeroed')) {
        ancestor.setAttribute('data-fw-gap-zeroed', '');
        ancestor.style.setProperty('padding-top', '0', 'important');
        break;
      }
      ancestor = ancestor.parentElement;
    }
  }

  

  
  
  
  
  
  
  function trackImageDimensions(root, uploadEl) {
    function tryCapture(e) {
      
      if (root.getAttribute("data-fw-img-w")) return;

      var detail = e.detail || {};
      var candidate = detail.file;
      var rawFile = null;

      if (candidate instanceof File) {
        rawFile = candidate;
      } else if (candidate && candidate.file instanceof File) {
        rawFile = candidate.file;
      } else if (candidate && candidate.source instanceof File) {
        rawFile = candidate.source;
      }

      if (!rawFile) {
        var nativeInput = uploadEl.querySelector('input[type="file"]');
        if (nativeInput && nativeInput.files && nativeInput.files[0]) {
          rawFile = nativeInput.files[0];
        }
      }

      if (!rawFile || rawFile.type.indexOf("image/") !== 0) return;

      var url = URL.createObjectURL(rawFile);
      var img = new Image();
      img.onload = function () {
        root.setAttribute("data-fw-img-w", String(img.naturalWidth));
        root.setAttribute("data-fw-img-h", String(img.naturalHeight));
        URL.revokeObjectURL(url);
      };
      img.onerror = function () { URL.revokeObjectURL(url); };
      img.src = url;
    }

    
    
    uploadEl.addEventListener("FilePond:addfilestart", tryCapture);
    uploadEl.addEventListener("FilePond:addfile", tryCapture);

    
    uploadEl.addEventListener("FilePond:removefile", function () {
      root.removeAttribute("data-fw-img-w");
      root.removeAttribute("data-fw-img-h");
    });
  }

  

  
  
  function parsePrintSizes(root) {
    try {
      return JSON.parse(root.getAttribute("data-fw-print-sizes") || "[]");
    } catch (e) {
      return [];
    }
  }

  
  
  function calcMinDpi(imgW, imgH, printWcm, printHcm) {
    var CM_PER_INCH = 2.54;
    var pWin = printWcm / CM_PER_INCH;
    var pHin = printHcm / CM_PER_INCH;
    
    var dpi1 = Math.min(imgW / pWin, imgH / pHin);
    
    var dpi2 = Math.min(imgW / pHin, imgH / pWin);
    return Math.max(dpi1, dpi2);
  }

  

  
  
  
  // Overall framed size in inches, standard mount. Matches the Size Guide.
  var FRAME_OUTER = {
    classic:    { w: 9.2,  h: 13.1 },
    standard:   { w: 13.1, h: 17 },
    statement:  { w: 17,   h: 21 },
    gallery:    { w: 21,   h: 24.9 },
    exhibition: { w: 24.9, h: 32.8 }
  };

  function stripColourNamePrefix() {
    var fieldset = document.querySelector('fieldset[data-handle="frame-colour"]');
    if (!fieldset) return;
    fieldset.querySelectorAll(".frame-product-option-value__name").forEach(function (el) {
      el.textContent = el.textContent.replace(/^The\s+/i, "");
    });
  }

  function injectSizeDimensions(root) {
    return;

    var fieldset = document.querySelector('fieldset[data-handle="frame-size"]');
    if (!fieldset) return;

    fieldset.querySelectorAll(".frame-product-option-value").forEach(function (btn) {
      if (btn.querySelector(".fw-size-dims")) return;

      var nameEl = btn.querySelector(".frame-product-option-value__name");
      if (!nameEl) return;

      var btnText = (nameEl.textContent || "").trim().toLowerCase();
      var ps = null;

      printSizes.forEach(function (p) {
        if (!ps && p.name.toLowerCase() === btnText) ps = p;
      });

      if (!ps) {
        printSizes.forEach(function (p) {
          if (!ps && btnText.indexOf(p.name.toLowerCase()) !== -1) ps = p;
        });
      }

      if (!ps && btnText.length >= 3) {
        printSizes.forEach(function (p) {
          if (!ps && p.name.toLowerCase().indexOf(btnText) !== -1) ps = p;
        });
      }

      if (!ps) return;

      var outer = FRAME_OUTER[ps.name.toLowerCase()] || null;
      var dims = document.createElement("span");
      dims.className = "fw-size-dims";
      if (outer) {
        dims.textContent = outer.w + "\u00d7" + outer.h + "in";
      } else {
        dims.textContent = (Math.round(ps.w / 2.54 * 10) / 10) + "\u00d7" + (Math.round(ps.h / 2.54 * 10) / 10) + "in";
      }
      btn.appendChild(dims);
    });
  }

  function isUpliftBlocked(btn) {
    if (btn.querySelector(".frame-product-option-value__size-issues")) return true;
    var wrap = btn.closest(".variant-input");
    if (wrap) {
      var radio = wrap.querySelector('input[type="radio"]');
      if (radio && radio.disabled) return true;
    }
    return false;
  }

  function countUpliftApproved() {
    var fieldset = document.querySelector('fieldset[data-handle="frame-size"]');
    if (!fieldset) return -1;
    var approved = 0;
    fieldset.querySelectorAll(".frame-product-option-value").forEach(function (btn) {
      if (!isUpliftBlocked(btn)) approved++;
    });
    return approved;
  }

  function getSizeBtnByName(name) {
    var fieldset = document.querySelector('fieldset[data-handle="frame-size"]');
    if (!fieldset) return null;
    var found = null;
    fieldset.querySelectorAll(".frame-product-option-value").forEach(function (btn) {
      var nameEl = btn.querySelector(".frame-product-option-value__name");
      if (nameEl && (nameEl.textContent || "").trim().toLowerCase() === name.toLowerCase()) {
        found = btn;
      }
    });
    return found;
  }

  function initSizeClickGate(root, steps, crumbs) {
    if (root.hasAttribute("data-fw-size-gate-init")) return;
    root.setAttribute("data-fw-size-gate-init", "true");

    var minDpi = parseInt(root.getAttribute("data-fw-min-dpi") || "150", 10);

    document.addEventListener("click", function (e) {
      if (document.body.getAttribute("data-fw-step") !== "2") return;

      var sizeOption = e.target.closest(
        '[data-handle="frame-size"] .frame-product-option-value'
      );
      if (!sizeOption) return;

      var nameEl = sizeOption.querySelector(".frame-product-option-value__name");
      if (!nameEl) return;

      var clickedName = (nameEl.textContent || "").trim().toLowerCase();
      var printSizes  = parsePrintSizes(root);
      var ps = null;
      printSizes.forEach(function (p) {
        if (p.name.toLowerCase() === clickedName) ps = p;
      });
      if (!ps) return;

      var imgW = parseInt(root.getAttribute("data-fw-img-w") || "0", 10);
      var imgH = parseInt(root.getAttribute("data-fw-img-h") || "0", 10);
      var approved = countUpliftApproved();
      var trustUplift = approved > 0;

      var dpiFail    = imgW && imgH && calcMinDpi(imgW, imgH, ps.w, ps.h) < minDpi;
      var upliftFail = trustUplift && isUpliftBlocked(sizeOption);
      var blocked    = dpiFail || upliftFail;

      if (blocked) {
        e.stopPropagation();
        e.preventDefault();
        showLowresLightbox(root, ps, printSizes, imgW, imgH, minDpi, steps, crumbs);
      }
    }, true);
  }

  function showLowresLightbox(root, badSize, allSizes, imgW, imgH, minDpi, steps, crumbs) {
    var lightbox = root.querySelector(".fw-lowres") ||
                   document.querySelector(".fw-lowres");
    if (!lightbox) return;

    var approved   = countUpliftApproved();
    var trustUplift = approved > 0;

    var goodSizes = allSizes.filter(function (ps) {
      if (ps.name.toLowerCase() === badSize.name.toLowerCase()) return false;
      if (imgW && imgH && calcMinDpi(imgW, imgH, ps.w, ps.h) < minDpi) return false;
      if (trustUplift) {
        var btn = getSizeBtnByName(ps.name);
        if (btn && isUpliftBlocked(btn)) return false;
      }
      return true;
    });

    var bodyEl = lightbox.querySelector("[data-fw-lowres-body]");
    if (bodyEl) {
      bodyEl.textContent =
        "Your photo is too small for " + badSize.name + " (" +
        badSize.w + "\u00d7" + badSize.h + " cm). " +
        "Choose a size below that works, or upload a higher-resolution photo.";
    }

    var sizesEl = lightbox.querySelector("[data-fw-lowres-sizes]");
    if (sizesEl) {
      if (goodSizes.length) {
        sizesEl.innerHTML =
          "<strong>Sizes that work with your photo:</strong><br>" +
          goodSizes.map(function (ps) {
            return ps.name + ", " + ps.w + "\u00d7" + ps.h + " cm";
          }).join("<br>");
        sizesEl.removeAttribute("hidden");
      } else {
        sizesEl.textContent =
          "Your photo is too small for all print sizes. " +
          "Please upload a higher-resolution image.";
        sizesEl.removeAttribute("hidden");
      }
    }

    lightbox.removeAttribute("hidden");
    document.body.classList.add("fw-lowres-open");
  }

  
  
  function initLowresLightbox(root, steps, crumbs) {
    var lightbox = root.querySelector(".fw-lowres") ||
                   document.querySelector(".fw-lowres");
    if (!lightbox) return;

    function close() { closeLowresLightbox(lightbox); }

    var closeBtn = lightbox.querySelector("[data-fw-lowres-close]");
    if (closeBtn) closeBtn.addEventListener("click", close);

    var backdrop = lightbox.querySelector(".fw-lowres__backdrop");
    if (backdrop) backdrop.addEventListener("click", close);

    var retryBtn = lightbox.querySelector("[data-fw-lowres-retry]");
    if (retryBtn) {
      retryBtn.addEventListener("click", function () {
        
        
        window.location.reload();
      });
    }

    document.addEventListener("keydown", function (e) {
      if ((e.key === "Escape" || e.keyCode === 27) &&
          !lightbox.hasAttribute("hidden")) {
        close();
      }
    });
  }

  function closeLowresLightbox(lightbox) {
    lightbox.setAttribute("hidden", "");
    document.body.classList.remove("fw-lowres-open");
  }

  

  
  
  
  
  
  
  function initCartRedirect() {
    if (window._fwCartRedirectInit) return;
    window._fwCartRedirectInit = true;

    function watchDrawer(drawer) {
      var obs = new MutationObserver(function () {
        var isOpen = !drawer.hasAttribute("hidden") &&
                     drawer.style.display !== "none" &&
                     getComputedStyle(drawer).display !== "none";

        if (isOpen) {
          drawer.setAttribute("hidden", "");
          drawer.style.display = "none";
          window.location.href = "/cart";
        }
      });
      obs.observe(drawer, {
        attributes: true,
        attributeFilter: ["hidden", "class", "style", "aria-expanded", "aria-hidden"]
      });
    }

    
    
    var drawer = document.getElementById("CartDrawer");
    if (drawer) {
      watchDrawer(drawer);
    } else {
      var bodyObs = new MutationObserver(function () {
        var el = document.getElementById("CartDrawer");
        if (el) { bodyObs.disconnect(); watchDrawer(el); }
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { try { bodyObs.disconnect(); } catch (e) {} }, 15000);
    }
  }

  

  
  
  
  
  
  function injectGiftFields(root, buyBtns) {
    if (document.querySelector("[data-fw-gift]")) return; 

    var giftHtml =
      '<div class="fw-gift" data-fw-gift>' +
        '<details class="fw-gift__details">' +
          '<summary class="fw-gift__toggle">' +
            '<span aria-hidden="true">&#127873;</span> Add a gift message' +
          '</summary>' +
          '<div class="fw-gift__body">' +
            '<label class="fw-gift__label">Recipient name' +
              '<input class="fw-gift__input" type="text" ' +
                'data-fw-gift-name autocomplete="off" ' +
                'placeholder="e.g. Mum, Sarah\u2026">' +
            '</label>' +
            '<label class="fw-gift__label">Gift note' +
              '<textarea class="fw-gift__textarea" ' +
                'data-fw-gift-note rows="3" maxlength="300" ' +
                'placeholder="Write your message here\u2026"></textarea>' +
              '<span class="fw-gift__counter" aria-live="polite">300 characters remaining</span>' +
            '</label>' +
          '</div>' +
        '</details>' +
      '</div>';

    
    
    
    if (buyBtns && buyBtns.parentNode) {
      buyBtns.insertAdjacentHTML("beforebegin", giftHtml);
    } else {
      var step3 = root.querySelector("[data-step='3']");
      if (step3) step3.insertAdjacentHTML("beforeend", giftHtml);
    }

    
    
    if (buyBtns) {
      var form = buyBtns.querySelector('form[action*="/cart/add"]') ||
                 buyBtns.querySelector("form");
      if (form) {
        var hiddenName = document.createElement("input");
        hiddenName.type = "hidden";
        hiddenName.name = "properties[Gift recipient]";
        hiddenName.setAttribute("data-fw-gift-name-hidden", "");
        form.appendChild(hiddenName);

        var hiddenNote = document.createElement("input");
        hiddenNote.type = "hidden";
        hiddenNote.name = "properties[Gift message]";
        hiddenNote.setAttribute("data-fw-gift-note-hidden", "");
        form.appendChild(hiddenNote);

        
        
        
        
        
        var nameEl = document.querySelector("[data-fw-gift-name]");
        var noteEl = document.querySelector("[data-fw-gift-note]");
        if (nameEl) {
          nameEl.addEventListener("input", function () {
            hiddenName.value = nameEl.value.trim();
          });
        }
        if (noteEl) {
          var counterEl = noteEl.parentNode && noteEl.parentNode.querySelector(".fw-gift__counter");
          noteEl.addEventListener("input", function () {
            hiddenNote.value = noteEl.value.trim();
            if (counterEl) {
              var remaining = 300 - noteEl.value.length;
              counterEl.textContent = remaining + " character" + (remaining === 1 ? "" : "s") + " remaining";
              counterEl.classList.toggle("fw-gift__counter--warn", remaining <= 30);
            }
          });
        }
      }
    }
  }

  

  function syncNavBarPrice() {
    var navPrice = document.querySelector(".fw-nav-bar__price");
    if (!navPrice) return;

    function readMotionPrice() {
      var src = document.querySelector(".product-block--price [data-product-price]") ||
                document.querySelector(".product-block--price .product__price") ||
                document.querySelector(".price-item--regular");
      if (src && src !== navPrice) {
        var t = src.textContent.trim();
        if (t) navPrice.textContent = t;
      }
    }

    document.addEventListener("change", function (e) {
      if (e.target && e.target.type === "radio" &&
          e.target.closest('[data-frame-ref="variantSelector"]')) {
        setTimeout(readMotionPrice, 400);
      }
    });

    var priceBlock = document.querySelector(".product-block--price");
    if (priceBlock) {
      new MutationObserver(readMotionPrice)
        .observe(priceBlock, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  syncNavBarPrice();
})();
